import { getListByDictType } from "@/api/sys/dictData";
const dict = {
    state:{
        injurySigmInGroup: [],//工伤鉴定签到分组
        injurySigmInType: [],//工伤鉴定签到方式
     },
    mutations: {
        SET_INJURY_SIGM_IN_TYPE: (state, injurySigmInType) => {
            state.injurySigmInType = injurySigmInType
        },
        SET_INJURY_SIGM_IN_GROUP: (state, injurySigmInGroup) => {
            state.injurySigmInGroup = injurySigmInGroup
        }
     },
     actions: {
        // 工伤鉴定签到分组
         getInjurySigmInGroup: async ({ commit }) => {
            const res = await getListByDictType('industrial_injury_work_injury_category')
            if (res?.code == 200) {
                commit("SET_INJURY_SIGM_IN_GROUP", res.data);
            }
         },
         // 工伤鉴定签到方式
          getInjurySigmInType: async ({ commit }) => {
           const res = await getListByDictType('industrial_injury_sign_type')
           if (res?.code == 200) {
               commit("SET_INJURY_SIGM_IN_TYPE", res.data);
           }
         }
     }
}
export default dict